



















































































































import Vue, { PropType } from "vue";
import "@/components/icons";
import Overlay from "@/components/Atoms/Overlay/index.vue";
import FloatingView from "@/components/Atoms/FloatingView/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import Body from "@/components/Atoms/Typography/Body/index.vue";
import Caption from "@/components/Atoms/Typography/Caption/index.vue";
import SearchSelectField from "@/components/Atoms/Forms/SearchSelectField/index.vue";
import Button from "@/components/Atoms/Button/index.vue";
import Radio from "@/components/Atoms/Forms/Radio/index.vue";
import ButtonConfig from "@/components/Molecules/ButtonConfig/index.vue";
import FloatingMenu from "@/components/Molecules/FloatingMenu/index.vue";
import FloatingMenuButton from "@/components/Atoms/FloatingMenuItems/FloatingMenuButton/index.vue";
import debounce from "lodash/debounce";
import { CombinedVueInstance } from "vue/types/vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "UniversityFloatingView",
  components: {
    Overlay,
    FloatingView,
    Heading,
    Body,
    Caption,
    SearchSelectField,
    Button,
    ButtonConfig,
    FloatingMenu,
    FloatingMenuButton,
    Radio
  },
  props: {
    universities: {
      type: Array as PropType<Props["universities"]>,
      required: true,
      default: () => []
    },
    messages: {
      type: Array as PropType<Props["messages"]>,
      required: true
    },
    updateUniversityObject: {
      type: Object as PropType<Props["updateUniversityObject"]>,
      required: true
    }
  },
  data() {
    return {
      $searchSelectFieldElement: null,
      isFloatingMenuVisible: false,
      isUniversitiesResponseNone: false,
      searchSelectFieldInputValue: this.updateUniversityObject.name,
      radioValue: this.updateUniversityObject.course,
      radioName: "category",
      options: [
        { value: "UNSPECIFIED", label: "未指定" }, // NOTE: 初期値
        { value: "HUMANITIES", label: "文系" },
        { value: "SCIENCE", label: "理系" }
      ]
    };
  },
  computed: {
    // getSelectFieldIdValue() {
    //   // NOTE: テキストフィールドで入力した大学名のIDを取得する
    //   const targetUniversity = this.universities.find(
    //     ({ name }) => name === this.searchSelectFieldInputValue
    //   );
    //   if (!targetUniversity) return -1;
    //   return targetUniversity.id;
    // }
    headingTitle() {
      return this.updateUniversityObject.update
        ? "スケジュールの編集"
        : "スケジュールの追加";
    },
    studentId() {
      return this.updateUniversityObject
        ? this.updateUniversityObject.studentId
        : 0;
    },
    isEditSearchSelectButtonVisible() {
      return this.updateUniversityObject
        ? this.updateUniversityObject.update
        : false;
    },
    isSameUpdateData() {
      if (
        this.updateUniversityObject.name === this.searchSelectFieldInputValue &&
        this.updateUniversityObject.course === this.radioValue
      ) {
        return true;
      } else {
        return false;
      }
    },
    isDisabled() {
      return (
        this.searchSelectFieldInputValue.length === 0 ||
        this.isUniversitiesResponseNone ||
        this.universities.every(
          e => e.name !== this.searchSelectFieldInputValue
        )
      );
    }
  },
  watch: {
    universities() {
      if (this.universities) {
        if (this.universities.length) {
          this.isFloatingMenuVisible = true;
          this.isUniversitiesResponseNone = false;
        } else {
          this.isFloatingMenuVisible = false;
          this.isUniversitiesResponseNone = true;
        }
      }
    }
  },
  mounted() {
    this.$searchSelectFieldElement = document.querySelector(
      ".searchFieldText__body"
    );
  },
  methods: {
    handleEventClickMenu(name: string) {
      this.searchSelectFieldInputValue = name;
      this.isFloatingMenuVisible = false;
    },
    handleRadioValueChange(radioValue: string) {
      this.radioValue = radioValue;
      if (this.searchSelectFieldInputValue === "") return;
      this.requestUniversityList(
        this.searchSelectFieldInputValue,
        this.radioValue
      );
    },
    handleSearchSelectFieldInput: debounce(function(
      this: CombinedVueInstance<Vue, Data, Methods, Computed, Props>,
      inputValue: string
    ) {
      if (inputValue === "") {
        this.isFloatingMenuVisible = false;
        this.isUniversitiesResponseNone = false;
      } else {
        this.requestUniversityList(inputValue, this.radioValue);
      }
    },
    500),
    handleUniversityFloatingViewClose() {
      this.$emit("closeUniversityFloatingView");
    },
    handleAddSearchSelectValue() {
      this.$emit(
        "addUniversity",
        this.searchSelectFieldInputValue,
        this.radioValue
      );
    },
    handleUpdateSearchSelectValue() {
      this.$emit(
        "updateUniversity",
        this.searchSelectFieldInputValue,
        this.radioValue,
        this.studentId
      );
    },
    requestUniversityList(inputValue: string, radioValue: string) {
      this.$emit("searchSelectFieldValue", inputValue, radioValue);
    },
    closeUniversityFloatingView() {
      this.$emit("closeUniversityFloatingView");
    }
  }
});
